import React from "react";
import { Card, Type } from "@ebscois/react-component-library";

const EndorserCard = () => {
  return (
    <Card
      border="gray400 solid 1px"
      backgroundColor="quinary"
      padding="sm"
      data-testid="endorser-blue-card"
    >
      <Type element="p" fontSize="sm">
        Topic reviewed and endorsed by:
      </Type>
      <Type element="p" fontWeight="bold" paddingTop="xs">
        Dr. Josepha Campinha-Bacote
      </Type>
      <Type element="i">Transcultural C.A.R.E. Associates</Type>
    </Card>
  );
};

EndorserCard.displayName = "EndorserCard";

export default EndorserCard;
